/*jshint esversion: 6 */

/**
 * Exports an object with keys & values for all the URL parameters.
 *
 * Ex:  /?utm_source=promo1
 *
 * {
 *   utm_source: "promo1"
 * }
 */
export default function QueryParams() {
  let tuples = window.location.search.substr(1).split('&'),
    i,
    len,
    lookup,
    parts,
    tuple
  if (!tuples) {
    return {}
  }
  lookup = {}
  for (i = 0, len = tuples.length; i < len; i++) {
    tuple = tuples[i]
    parts = tuple.split('=')
    if (parts.length !== 2) {
      continue
    }
    lookup[parts[0]] = decodeURIComponent(parts[1].replace(/\+/g, ' '))
  }
  return lookup
}
